export default __webpack_public_path__ + "static/media/detail_mobile_1_1.c00c0e85.png";